import { ProjectType } from '@/types/enums/project-type'

/**
 * DEV-222: path-таксономия типов недвижимости.
 * Фильтр по типу выражается сегментом /{locale}/properties/{type-slug}[/page/N]
 * вместо числового ?type=N.
 *
 * Источник истины для slug↔ProjectType — зеркало backend/ssr:
 *   backend/ssr/internal/domain/services/property_type.go (slugToProjectType).
 * Slug-набор ЗАКРЫТЫЙ (4 значения) — это позволяет матчить его regex-альтернацией
 * ДО открытого city-slug в роутере, снимая коллизию city/type.
 * Образец паттерна — ARTICLE_SECTIONS / article-routes.ts.
 */

/** ProjectType → url-slug (закрытый набор; INVALID=0 не маппится). */
export const PROJECT_TYPE_TO_SLUG: Partial<Record<ProjectType, string>> = {
  [ProjectType.RESIDENTIAL_COMPLEX]: 'residential-complex',
  [ProjectType.GATED_COMMUNITY]: 'gated-community',
  [ProjectType.HOLIDAY_HOMES]: 'holiday-homes',
  [ProjectType.COMMERCIAL_REAL_ESTATE]: 'commercial',
}

/** url-slug → ProjectType (обратный маппинг). */
export const SLUG_TO_PROJECT_TYPE: Record<string, ProjectType> = Object.entries(
  PROJECT_TYPE_TO_SLUG
).reduce<Record<string, ProjectType>>((acc, [type, slug]) => {
  acc[slug as string] = Number(type) as ProjectType
  return acc
}, {})

/** Закрытый список type-slug в детерминированном порядке (для regex роутов). */
export const PROPERTY_TYPE_SLUGS = Object.values(PROJECT_TYPE_TO_SLUG) as string[]

/** Regex-альтернация для path-параметра роута: residential-complex|gated-community|... */
export const PROPERTY_TYPE_SLUG_PATTERN = PROPERTY_TYPE_SLUGS.join('|')

/** Slug по ProjectType (пустая строка, если тип вне 1..4). */
export function getPropertyTypeSlug(type: ProjectType): string {
  return PROJECT_TYPE_TO_SLUG[type] ?? ''
}

/** ProjectType по slug (undefined, если slug не из закрытого набора). */
export function getProjectTypeBySlug(slug: string | undefined): ProjectType | undefined {
  if (!slug) return undefined
  return SLUG_TO_PROJECT_TYPE[slug]
}
